let photoSwipeModules;

async function loadPhotoSwipeModules() {
  if (!photoSwipeModules) {
    photoSwipeModules = Promise.all([
      import("./photoswipe-lightbox-5.4.3.esm.js"),
      import("./photoswipe-5.4.3.esm.js"),
    ]).then(([lightboxModule, photoSwipeModule]) => ({
      PhotoSwipeLightbox: lightboxModule.default,
      PhotoSwipe: photoSwipeModule.default,
    }));
  }

  return photoSwipeModules;
}

document.addEventListener("DOMContentLoaded", () => {
  const rteElements = document.querySelectorAll(".rte");

  rteElements.forEach((rte) => {
    const images = rte.querySelectorAll("img");

    images.forEach((img) => {
      // Skip if already wrapped in an anchor or if it's a small icon
      if (img.closest("a") || img.width < 50 || img.height < 50) return;

      const anchor = document.createElement("a");
      anchor.href = img.src;
      anchor.dataset.pswpWidth = img.naturalWidth || img.width;
      anchor.dataset.pswpHeight = img.naturalHeight || img.height;
      anchor.target = "_blank";
      anchor.classList.add("lightbox-image");

      // Update dimensions if naturalWidth is not yet available
      if (!img.naturalWidth) {
        img.onload = () => {
          anchor.dataset.pswpWidth = img.naturalWidth;
          anchor.dataset.pswpHeight = img.naturalHeight;
        };
      }

      img.parentNode.insertBefore(anchor, img);
      anchor.appendChild(img);
    });

    rte.addEventListener("click", async (event) => {
      const clickedImage = event.target.closest("a.lightbox-image");

      if (!clickedImage || !rte.contains(clickedImage)) {
        return;
      }

      event.preventDefault();

      const { PhotoSwipeLightbox, PhotoSwipe } = await loadPhotoSwipeModules();
      const lightbox = new PhotoSwipeLightbox({
        gallery: rte,
        children: "a.lightbox-image",
        pswpModule: PhotoSwipe,
        bgOpacity: 0.9,
        showHideAnimationType: "zoom",
      });

      lightbox.init();
      const index = Array.from(rte.querySelectorAll("a.lightbox-image")).indexOf(clickedImage);
      lightbox.loadAndOpen(Math.max(index, 0));
    });
  });
});
